// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ig-0";
export var fulfillmentPanelBody = "_ig-1";